/* eslint-disable react-hooks/exhaustive-deps */
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import { DropDownFilter } from 'components/InputsMex/inputs';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import useParametrosPago from 'redux/hooks/useParametrosPago';
import TARJETAS from 'utils/constants/TARJETAS';

const ResumenDatosPlan = ({ plan, tarifar, datosTarifacion, prod }) => {
  const [showOpciones, setshowOpciones] = useState(false);
  const [showLogos, setShowLogos] = useState(false);

  const { parametros, setCombos, ...stateParametrosPago } = useParametrosPago();

  const methods = useFormContext();

  const { getValues } = methods;

  const onChangeFormPago = (value) => {
    if (value.onChange === 'recalcular') {
      tarifar({ idPlazo: value.id, formaPago: value.tipo, labelPlazo: value.label });
      setShowLogos(false);
    } else {
      setShowLogos(true);
    }
    setshowOpciones(value?.mostrarSubopciones);
  };

  const onChangePlazo = (value) => {
    const formaPago = getValues('formaPago');
    tarifar({
      idPlazo: value.ID,
      formaPago: formaPago.tipo,
      labelPlazo: value.Name,
    });
  };

  useEffect(() => {
    setCombos({
      formaPago: datosTarifacion.formaPago,
      idPlazo: datosTarifacion.idPlazo,
      setShowLogos,
      setshowOpciones,
      reset: methods.reset,
    });
  }, [parametros]);

  return (
    <React.Fragment>
      <div className="col-10 col-md-6 border-mex-ap ">
        <div className="row">
          <div className="col-11 mt-5 mx-auto">
            <h3 className="font-mex text-center">
              ¡Has elegido <strong>{prod.producto}!</strong>
            </h3>

            <div className="row justify-content-center mt-3 mb-5">
              <div className="col-11 col-md-8 border-mex-ap text-center py-4">
                <div
                  className="text-center"
                  style={{
                    backgroundColor: plan.bgColor,
                    fontSize: '20px',
                    paddingBottom: '0.5rem',
                    paddingTop: '0.3rem',
                    width: '100%',
                    margin: '0 0 0 0 ',
                    paddingLeft: '0',
                    paddingRight: '0',
                  }}
                >
                  <h4 className="font-mex text-mex mt-2">{plan.producto}</h4>
                </div>
                <h2 className="font-mex">
                  ${datosTarifacion.precioProducto}{' '}
                  {datosTarifacion.monedaSimbolo.toLowerCase()}
                </h2>
              </div>
            </div>
          </div>

          <div className="col-11 ml-4">
            <h2 className="font-mex mb-3">
              Datos del {plan.producto.toLowerCase()}
            </h2>

            {plan.coberturas.map((cob, index) => (
              <div className="row" key={index}>
                <div className="col-7 align-self-center">
                  <p
                    className="font-source-sans-regular"
                    style={{ fontSize: '20px', fontWeight: '100' }}
                  >
                    {cob.nombre}
                  </p>
                </div>
                <div className="col-5 align-self-center text-right">
                  <p className="" style={{ fontSize: '20px' }}>
                    {cob.precio}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="col-12">
            <div className="row">
              <div className="col-xl-6">
                <SimpleContainer
                  name="formaPago"
                  label="Opción de pago"
                  helpText={
                    stateParametrosPago.loading && 'Cargando formas de pago...'
                  }
                >
                  <DropDownFilter
                    name="formaPago"
                    filter={false}
                    rules={{ required: 'Obligatorio' }}
                    options={parametros?.formasPago}
                    onChangeFn={onChangeFormPago}
                    loading={stateParametrosPago.loading}
                    loadingText={stateParametrosPago?.loading && 'Cargando...'}
                  />
                </SimpleContainer>
              </div>

              {showOpciones && (
                <div className="col-xl-6">
                  <SimpleContainer label="Elije cuántos meses" name="idPlazo">
                    <DropDownFilter
                      name="idPlazo"
                      filter={false}
                      rules={{ required: 'Obligatorio' }}
                      options={parametros.plazos}
                      onChangeFn={onChangePlazo}
                      loading={stateParametrosPago?.loading}
                    />
                  </SimpleContainer>
                </div>
              )}
            </div>
          </div>

          {showLogos && (
            <div className="col-12">
              <div className="ml-4">
                <h4>Tarjetas participantes</h4>

                {TARJETAS.APINDIVIDUAL.map((tarjeta, index) => (
                  <img
                    {...tarjeta}
                    key={index}
                    alt={tarjeta.alt}
                    style={{ width: '200px' }}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ResumenDatosPlan;
